
// utils/statusStyles.js
export const getStatusStyle = (status) => {
  switch (status?.toLowerCase()) {
    case "paid":
    case "in":      
      return { color: "green" };
    case "cancelled":
    case "failed":
    case "rejected":
    case "out":  
      return { color: "red" };
    case "pending":
    case "draft":
    case "rfq":
      return { color: "#DFA226" };
    case "purchase_order":
    case "sale_order":
    case "sales_return":
    case "purchase_return":
    case "processing":
    case "in_transit":
    case "approved":
      return { color: "#094C80" };
    case "received":
    case "returned":
    case "completed":
    case "refunded":
    case "delivered":
        return {color: "#07782D"}
    
    case "open":
        return {color: "#58A6E3"}

    case "partially_paid":
        return {color: "#345742"}
  }
};
